import React from "react";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import productByIdStore from "../../flux/stores/product/ByIdStore";

import * as CONSTANTS from "../../utilities/Constants";

import ProductViewData, {
  defaultProductData,
} from "../../models/product/ProductViewData";

import "./product.sass";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import History from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  productData: ProductViewData;
  isShow: boolean;
}

export default class Landing extends React.Component<{}, ILandingState> {
  private _mount: boolean = false;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      productData: defaultProductData,
      isShow: true,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    productByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ productData: state.productData });
      }
    });
  }
  private onToggleShow = () => {
    this.setState({
      isShow: !this.state.isShow,
    });
  };
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };
  public render() {
    const list = [
      ...this.state.productData.keyedInProperties,
      ...this.state.productData.measuredProperties,
      ...this.state.productData.calculatedProperties,
    ];

    return (
      <Translation>
        {(t) => (
          <div className="page-layout">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.MENU_PRODUCT), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader
            authKey={CONSTANTS.AUTHKEY_PRODUCT}
              data={this.state.productData.name}
              isEnable={this.state.productData.isEnabled}
              isEnabeDisableButton={true}
            />
            <div className="summary-layout">
              <Summary>
                <div className="page-scroll">
                  <div className="row mt-3">
                    <div className="col-md-4 d-flex">
                      <span className="summary-label" style={{ width:'54px' }}>
                        {" "}
                        {t(this.state.productData.gradeNameLabel)}:{" "}
                      </span>
                      <span className="summary-value ml-2 name-overflow">
                        {this.state.productData.grade.name}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="summary-label">
                        {t(this.state.productData.codeLabel)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.productData.code}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="summary-label">
                        {t(this.state.productData.stateLabel)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.productData.state}
                      </span>
                    </div>
                  </div>

                  <div className="row mt-3">
                  <div className="col-md-12" style={{ display:'flex' }}>
                      <span className="summary-label">
                        {t(this.state.productData.descriptionLabel)}:
                      </span>
                    <div className="ellipsis-single-line" style={{lineHeight:'20px'}}>
                      <span className="ml-2 summary-value">
                        {this.state.productData.description}
                      </span>
                    </div>
                    </div>
                  </div>
                </div>
              </Summary>
              <div className="summary-layout">
                <AbbTableComponent
                authKey={CONSTANTS.AUTHKEY_PRODUCT}
                  columns={[
                    {
                      dataField: "property.propertyNameDirection",
                      text: t(CONSTANTS.MODULE_PROPERTY),
                      isFixed: true,
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return {
                          width: "15%",
                          textAlign: "left",
                          fontWeight: "bold",
                        };
                      },
                    },
                    {
                      dataField: "property.customId",
                      text: t(CONSTANTS.LABLE_ID),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "target",
                      text: t(CONSTANTS.TARGET),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "sigma",
                      text: t(CONSTANTS.SIGMA),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "minValue",
                      text: t(
                        CONSTANTS.LABLE_MIN + " " + CONSTANTS.LABEL_VALUE
                      ),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "maxValue",
                      text: t(
                        CONSTANTS.LABLE_MAX + " " + CONSTANTS.LABEL_VALUE
                      ),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "alarmLow1",
                      text: t(CONSTANTS.ALARMLOWONE),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "alarmHigh1",
                      text: t(CONSTANTS.ALARMHIGHONE),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "alarmLow2",
                      text: t(CONSTANTS.ALARMLOWTWO),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "alarmHigh2",
                      text: t(CONSTANTS.ALARMHIGHTWO),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "rejectLow",
                      text: t(CONSTANTS.REJECTLOW),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "rejectHigh",
                      text: t(CONSTANTS.REJECTHIGH),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "gain",
                      text: t(CONSTANTS.GAIN),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "offset",
                      text: t(CONSTANTS.OFFSET),
                      editable: false,
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                  ]}
                  list={list?.sort((a, b) => a.order - b.order)}
                  select={false}
                  isFixedColumn={true}
                  isEditable={false}
                  delete={false}
                  isTitle={
                    <div>
                      <p className="sidebar-main-title font-weight-bold">
                        {t(CONSTANTS.PRODUCT_QUALITY_SPECS)}
                      </p>
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
